import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/auth_slice'
import vehicleReducer from './vehicles/vehicle_slice'
import userReducer from './users/users_slice'
import promoReducer from './promotions/promotion_slice'
import rideReducer from './rides/ride_slice'
import configReducer from './config/config_slice'
import supportReducer from './support/support_slice'
import notificationReducer from './notifications/notifications_slice'
import paymentMethodsReducer from './payment_methods/payment_methods_slice'
import transactionReducer from './transactions/transaction_slice'
import refundsReducer from './refunds/refunds_slice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    vehicle: vehicleReducer,
    user: userReducer,
    promotion: promoReducer,
    config: configReducer,
    ride: rideReducer,
    support: supportReducer,
    notification: notificationReducer,
    refund: refundsReducer,
    transaction: transactionReducer,
    payment_method: paymentMethodsReducer,
  }
})